import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as Actions from '../../store/actions';
import { TextField } from '@material-ui/core';
import * as CanvasFunctions from '../../components/CanvasFunctions';
import '../../../../../styles/canvas.css';


class HotSpotAnswer extends Component {
    svgRef = React.createRef();
    state = {
        selectedPosition: null,
        svgCoord: {}
    }

    componentDidMount = () => {
        this.setState({
            svgCoord: this.svgRef.current.getBoundingClientRect(),
        });
    }

    handleMouseDown = (event) => {
        const { question }     = this.props;
        const question_id      = question.header.question_id;
        const question_type_id = question.header.question_type_id;
        const svgCoord         = this.svgRef.current.getBoundingClientRect();

        const { x, y } = CanvasFunctions.getCoords(event, svgCoord);
        const selectedPosition = {
            type: "cross",
            id: 1,
            xPosition:  x,
            yPosition:  y,
        }

        this.props.selectAnswer(question_id, question_type_id, CanvasFunctions.getRelativeCoordinatesForObj(selectedPosition, svgCoord));
        this.setState({
            selectedPosition: selectedPosition
        });
    }
    
    getAnswerContent = () => {
        const { question, studentAnswers } = this.props;
        const question_id = question.header.question_id;

        let obj_list = [];
        if (typeof studentAnswers[question_id] !== 'undefined') {
            obj_list.push(CanvasFunctions.parseRelativeCoordinatesForObj(studentAnswers[question_id], this.state.svgCoord));
        }

        return (
            <div className="canvas">
                <svg
                    onMouseDown = {this.handleMouseDown}
                    ref         = {this.svgRef}
                    style       = {{ cursor: "pointer" }}
                >
                    <image href={question.image.URL} />
                    {CanvasFunctions.renderCanvas(obj_list)}
                </svg>
            </div>
        )
    }

    render() {
        const { answer, question } = this.props;

        if (typeof question === 'undefined') {
            return <div>Loading Answer...</div>
        }

        return (
            <div className="canvas_wrapper">
                {this.getAnswerContent()}
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        selectAnswer: Actions.selectAnswer,
    }, dispatch);
}

function mapStateToProps({ quizApp }) {
    return {
        studentAnswers: quizApp.quizViewer.studentAnswers
    }
}

export default withStyles(null, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(HotSpotAnswer)));




// WEBPACK FOOTER //
// src/main/content/quiz/quizViewer/questionType/HotSpotAnswer.js